module.exports = __webpack_public_path__ + "static/fonts/icomoon.1ed0bd1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/fonts/icomoon.woff?3oykl7
// module id = Nwc5
// module chunks = 6